import { wgs2gcj } from '@/util/map/proj'
import Log from './partial/log'
export default {
  data() {
    return {
      data: {},
      modalVisible:false,
      reviewable:false
    }
  },


  methods: {

    review(){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review id={this.id} />
        },
        onOk: () => {
          this.query()
        }
      })
    },

    init(id , reviewable = false) {
      this.id = id
      this.modalVisible = true
      this.reviewable = reviewable
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.company(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , {'establishDatetime':'date' , 'companyType':'companyType' , 'companyNature':'companyNature','runType':'runType','areaLabel':'area','createDatetime':'datetime'})
        if (resp.data.latitude && resp.data.longitude) {
          this.data.location = [resp.data.longitude , resp.data.latitude]
        }

        if( resp.data.files ){
          for(let i of resp.data.files ){
            if(!this.data['photo'+i.fileType]) this.data['photo'+i.fileType] = []
            this.data['photo'+i.fileType].push( i.filePath )
          }
        }
      })
    }
  },

  render(){
    const data = this.data || {}
    //col={3} layout="vertical"

    const title = '查看企业'
    return (
      <sl-side-panel v-model={this.modalVisible} mask-closable={false} title={title}>
        <Tabs value="t1">
          <TabPane label="基本信息" name="t1">
            <sl-detail-list label-width="120px" col={1} label-align="right" style="padding:12px;">
              <sl-detail-list-item title="企业名称" content={data.companyName}>
              </sl-detail-list-item>
              <sl-detail-list-item title="统一信用代码" content={data.unionCreditCode}>
              </sl-detail-list-item>
              <sl-detail-list-item title="企业简称" content={data.shortName}>
              </sl-detail-list-item>
              <sl-detail-list-item title="上家企业" content={data.parentName}>
              </sl-detail-list-item>
              <sl-detail-list-item title="运营方式" content={data.runTypeText} />
              <sl-detail-list-item title="企业类型" content={data.companyTypeText}>
              </sl-detail-list-item>
              <sl-detail-list-item title="企业性质" content={data.companyNatureText}>
              </sl-detail-list-item>
              <sl-detail-list-item title="负责人" content={data.legalName}>
              </sl-detail-list-item>
              <sl-detail-list-item title="联系方式" content={data.companyPhone}>
              </sl-detail-list-item>
              <sl-detail-list-item title="存量车整改数量" content={data.storageCount} />
              <sl-detail-list-item title="品牌" content={data.brandName}>
              </sl-detail-list-item>
              <sl-detail-list-item title="所属区域" content={data.areaLabel}>
              </sl-detail-list-item>
              <sl-detail-list-item title="成立时间" content={data.establishDatetimeText}>
              </sl-detail-list-item>
              <sl-detail-list-item title="注册地址" content={data.regAddress}>
              </sl-detail-list-item>
              <sl-detail-list-item title="所在地址" content={data.businessAddress}>
              </sl-detail-list-item>
              <sl-detail-list-item label="网点照片">
                <sl-carousel width="150px" images={data.photo21} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item label="备案申请表">
                <sl-carousel width="150px" images={data.photo22} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item label="营业执照">
                <sl-carousel width="150px" images={data.photo23} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item label="负责人身份证正面">
                <sl-carousel width="150px" images={data.photo24} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item label="负责人身份证背面">
                <sl-carousel width="150px" images={data.photo25} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item label="快递经营许可证">
                <sl-carousel width="150px" images={data.photo26} public={true} />
              </sl-detail-list-item>
              <sl-detail-list-item title="地理位置">
                <sl-amap style="height:300px;">
                  <sl-amap-marker center={data.location} cs="wgs84" />
                </sl-amap>
              </sl-detail-list-item>
              <sl-detail-list-item title="备注" content={data.remark}>
              </sl-detail-list-item>
            </sl-detail-list>
          </TabPane>
          {
            this.$a('company.info.query.changes') ? <TabPane label="变更记录" name="t2">
            <Log id={this.id} raw={data} />
          </TabPane> : null
          }
          
        </Tabs>
      </sl-side-panel>
    )
  }
}
